import './SeoContentBlock.scss';

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../hooks/useTheme';
import { convertStringToValidHtml } from '../../utilities/lister-utilities';
import { Breakpoint } from '../../utilities/ui-utilities';
import SeoBlockAOSmile from './SeoBlockAOSmile';

const SmileBackground = ({ fill }) => (
	<Breakpoint.SmallAndAbove>
		<div className="lister__seo-content-block-smile-svg -mt-32">
			<SeoBlockAOSmile width="1200" height="396" fill={fill} />
		</div>
	</Breakpoint.SmallAndAbove>
);

export const SeoContentBlock = () => {
	const {
		seoHtml: { SeoContentCollection, SeoContentBody } = {},
	} = useSelector((state) => state);

	const theme = useTheme('seo');

	if (SeoContentCollection?.length > 0) {
		// Multi SEO blocks

		return (
			<div
				className={classnames(
					'lister__seo-content-block lister__seo-content-block--rebrand py-12 md:pb-0 px-4 text-body-xs overflow-hidden',
					theme.background,
					theme.text
				)}
				data-testid="seo-multi-block">
				<div className="lister__seo-content-block-inner u-z--1 relative">
					{SeoContentCollection.map((content, index) => (
						<div
							className={classnames({
								'u-mt--small': index > 0,
							})}
							key={`seo-multi-block-${index + 1}`}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: convertStringToValidHtml(content),
							}}
						/>
					))}
				</div>
				<SmileBackground fill={theme.fill} />
			</div>
		);
	} else if (SeoContentBody) {
		// Singular SEO block

		return (
			<div
				className="lister__seo-content-block lister__seo-content-block--rebrand py-12 md:pb-0 px-4 bg-darkgreen text-body-xs text-white overflow-hidden"
				data-testid="seo-block">
				<div
					className="lister__seo-content-block-inner relative"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: convertStringToValidHtml(SeoContentBody),
					}}
				/>
				<SmileBackground fill={theme.fill} />
			</div>
		);
	}

	return null;
};

export default SeoContentBlock;
